import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class MeasureReferenceData extends EntityData<MeasureReferenceData> {
    @identifier measureId: number;
    @field name: string;
    @field symbol: string;
    @field base: boolean = false;
    @field ctnQty: number;
}

export class BaseConversion extends EntityData<BaseConversion> {
    @field factor: number = null;
    @component convertTo: MeasureReferenceData;
}

export class MeasureData extends MeasureReferenceData {
    @component baseConversion: BaseConversion;
    hasCntQty: boolean = false;
}
